import { INITIAL_PROPERTY_SPACE_RANGE } from './property-space.state';
import { immerOn } from 'ngrx-immer/store';
import {
  resetPropertySpaceFilter,
  setPropertySpaceFilter,
  setPropertySpaceFilterBasedOnUrlValues,
} from './property-space.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  PropertySpaceFilterState,
  PropertySpaceRange,
} from '@immosky/types';

export const initialPropertySpaceState: PropertySpaceFilterState = {
  isActive: false,
  isDisplayed: false,
  options: [],
  filter: INITIAL_PROPERTY_SPACE_RANGE,
  default: INITIAL_PROPERTY_SPACE_RANGE,
};

export const propertySpaceReducers = [
  immerOn(setPropertySpaceFilter, (state: FilterState, { filter }) => {
    updatePropertySpaceFilter(state, filter);
  }),
  immerOn(resetPropertySpaceFilter, resetAllFilters, (state: FilterState) => {
    updatePropertySpaceFilter(state, state.propertySpace.default);
  }),
  immerOn(
    setPropertySpaceFilterBasedOnUrlValues,
    (state: FilterState, { values }) => {
      const options = state.propertySpace.options;
      const minOption = options.find((o) => o.value === values.min);
      const maxOption = options.find((o) => o.value === values.max);

      if (minOption) {
        state.propertySpace.filter.min = minOption;
      }

      if (maxOption) {
        state.propertySpace.filter.max = maxOption;
      }

      state.propertySpace.isActive = isPropertySpaceFilterActive(
        state.propertySpace.filter,
        state.propertySpace.default
      );
    }
  ),
];

export function updatePropertySpaceFilter(
  state: FilterState,
  filter: PropertySpaceRange
) {
  state.propertySpace.filter = filter;
  state.propertySpace.isActive = isPropertySpaceFilterActive(
    state.propertySpace.filter,
    state.propertySpace.default
  );
}

export function isPropertySpaceFilterActive(
  filter: PropertySpaceRange,
  defaultFilter: PropertySpaceRange
): boolean {
  const isMinLivingSpaceDefault = filter.min.value === defaultFilter.min.value;
  const isMaxLivingSpaceDefault = filter.max.value === defaultFilter.max.value;
  return !(isMinLivingSpaceDefault && isMaxLivingSpaceDefault);
}
